import { mapActions, mapGetters } from 'vuex';
import { nameSpace as CSOperatorNameSpace } from '@/vue/stores/CSOperator/CSOperatorStore';

export default {
  data() {
    return {
      csOperatorCurrency: null,
      csOperatorMileage: null,
      csOperatorUserData: null,
    };
  },

  computed: {
    ...mapGetters(CSOperatorNameSpace, [
      'getCurrentCSOperator',
      'getCSOperatorCollection',
      'findOperatorBy',
      'findCSOperatorByUUID',
      'getVisitedCsOperator',
    ]),
  },

  methods: {
    ...mapActions(CSOperatorNameSpace, [
      'setCurrentCSOperator',
      'addCSOperatorInCollection',
      'setCSOperatorCollection',
      'setVisitedCsOperator',
      'fetchCSOperator',
      'resetCSOperatorStore',
    ]),
  },
};
